import React from 'react'
import {Hsn, Price, Total, AddRetnRow,  Cgst, Igst, Sgst} from './rowelements/others'

import NameElement from './rowelements/nameelement'
import ClientElement from './rowelements/clientelement'
import OutState from './rowelements/outstate'
import RetnTotal from './rowelements/retntotal'
import SellingBasicRate from './rowelements/sellingbasicrate'

import RetnDate from './rowelements/retndate'
import QuantityElement from './rowelements/quantity'
import Discount from './rowelements/discount'
import {Loader} from '../../utils/misc'

import {Link } from 'react-router-dom'
import {getToken, getUserProfile} from '../../storage'
import {NotificationManager} from 'react-notifications'
import {API_BASE_URL} from '../../constants'
import {basicRate,calculateSellingPrice, calculateDiscount} from '../../utils/calculator'
import axios from 'axios'
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class ResponsiveRow extends React.Component {

  render() {
      let item = this.props.item
      let retn = this.props.retn
      let td_gst
      if(retn.is_igst) {
        td_gst = <div className="row">
            <div className="col-xs-12">
              <label className="hidden-md hidden-lg mtop">IGST</label>
               <Igst item={item}  />
            </div>
        </div>
      }
      else {
        td_gst = <div className="row">
              <div className="col-xs-6">
                <label className="hidden-md hidden-lg mtop">CGST</label>
                 <Cgst item={item}  />
              </div>
              <div className="col-xs-6">
                <label className="hidden-md hidden-lg mtop">SGST</label>
                 <Sgst item={item}  />
              </div>
            </div>
      }

      return <div className="responsive-row">
        <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label className="hidden-md hidden-lg mtop">Name</label>
                <NameElement item={item} onAddCallback={this.props.handleUpdateItem} />
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">HSN</label>
                <Hsn item={item} />
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Quantity</label>
                <QuantityElement item={item} onChangeCallback={this.props.handleUpdateQuantity} />
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Unit Rate</label>
                <SellingBasicRate item={item} onChangeCallback={this.props.handleUpdateBasicRate} />
              </div>

              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Discout</label>
                <Discount item={item} onChangeCallback={this.props.handleUpdateQuantity} />
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Taxable Price</label>
                <Price item={item}  />
              </div>

              <div className="col-xs-6 col-sm-4 col-md-2">
                {td_gst}
              </div>
              <div className="col-xs-6 col-sm-4 col-md-1">
                <label className="hidden-md hidden-lg mtop">Total</label>
                <Total item={item} />
              </div>
              <div className="col-xs-6 col-sm-4 col-md-1 mtop">
                <button className="btn btn-danger btn-xs" onClick={(e)=>{this.props.deleteRow(item.tableIndex)} } >Delete</button>
              </div>


        </div>
      </div>



  }
}


class ResonsiveHeader extends React.Component {
  render() {
    let retn = this.props.retn

    let igst_header
    if(retn.is_igst) {
      igst_header = <div className="row"><div className="col-xs-12">IGST</div></div>

    }
    else {
      igst_header = <div className="row"><div className="col-xs-6">CGST</div><div className="col-xs-6">SGST</div></div>
    }

    return <div className="responsive-header hidden-xs hidden-sm"><div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            Name
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            HSN/SAC
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            Quantity
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            Unit Rate
          </div>

          <div className="col-xs-6 col-sm-2 col-md-1">
            Discount
          </div>
          <div className="col-xs-4 col-sm-2 col-md-1">
            Taxable Price
          </div>

          <div className="col-xs-4 col-sm-4 col-md-2">
            {igst_header}
          </div>
          <div className="col-xs-4 col-sm-4 col-md-1">
            Total
          </div>
          <div className="col-xs-6 col-sm-4 col-md-1">
          </div>
    </div></div>

  }
}

export default class CreditNote extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      loading:true,
      retn: {

      }
    }
    this.handleClientChange = this.handleClientChange.bind(this)
    this.handleDateChange= this.handleDateChange.bind(this)
    this.handleReasonChange = this.handleReasonChange.bind(this)
    this.handleOutStateChange = this.handleOutStateChange.bind(this)
    this.handleUpdateItem = this.handleUpdateItem.bind(this)
    this.modifyItemState = this.modifyItemState.bind(this)
    this.handleAddItem = this.handleAddItem.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleAddRow = this.handleAddRow.bind(this)
    this.handleCalculateTotal = this.handleCalculateTotal.bind(this)
    this.handleUpdateQuantity = this.handleUpdateQuantity.bind(this)
    this.handleUpdateBasicRate = this.handleUpdateBasicRate.bind(this)
    this.handleUpdateSellingPrice = this.handleUpdateSellingPrice.bind(this)
    this.getDiscount = this.getDiscount.bind(this)
    this.deleteRetn = this.deleteRetn.bind(this)
    this.submit = this.submit.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.getClientInvoices = this.getClientInvoices.bind(this)
    this.handleInvoiceChange = this.handleInvoiceChange.bind(this)
  }

  getClientInvoices(client_id) {
    return axios({
      url: '/list_invoices/?client_id='+client_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  handleUpdateBasicRate(item) {
    // calculate selling price
    var b = item['selling_basic_rate']
    if (isNaN(b)) {
      b = 0
    }


      if(typeof item.gst !== "undefined" && item.gst !== null) {
            let gst_pct = parseFloat(item.gst.igst)
            item['selling_rate'] = calculateSellingPrice(b, gst_pct)
      }
      this.handleUpdateQuantity(item)
  }

  handleReasonChange(e){
    this.modifyItemState('reason', e.target.value)
  }


  handleUpdateSellingPrice(item) {
    // calculate basic rate
    var s = item['selling_rate']
    if (isNaN(s)) {
      s = 0
    }
    else {

      if(typeof item.gst !== "undefined" && item.gst !== null) {

          let gst_pct = 0
          if(item.gst.type === "C") {
            gst_pct = parseFloat(item.gst.cgst) + parseFloat(item.gst.sgst)

          }
          else {
            gst_pct = parseFloat(item.gst.igst)
          }
            item['selling_basic_rate'] = basicRate(s, gst_pct)

            this.handleUpdateQuantity(item)
      }
    }
  }

  componentDidMount() {

    let params = this.props.match.params
    if(typeof params.retn_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Credit Note " + this.props.match.params.retn_id
      this.getRetn(this.props.match.params.retn_id).then((response)=>{
        if(response.status===200) {
          console.log(response.data.retn);
          this.setState({retn: response.data.retn, loading:false, retn_item_tableindex: response.data.retn.retnitem_set.length})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Create Credit Note "
        this.setState({loading:false})
        this.handleAddRow()
    }

  }

  getRetn(retn_id) {
    return axios({
      url: '/get_retn/?serial='+retn_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  getDiscount(item) {

    // calculate discount
    let quantity = parseFloat(item.quantity)
    if(quantity <= 0) {
      item['discount_value'] = 0
    }
    else if( typeof item['discount_edited'] !== "undefined" ) {
      item['discount_value'] = parseFloat(item['discount_edited'])
    }
    else {
      let discount_set = item.discount_set
      let matchingDiscount
      if(typeof discount_set !== "undefined" && discount_set !== null) {

        // sort discount set with respect to quantity
        discount_set = discount_set.sort((a,b)=>{
          return b.quantity - a.quantity
        })

        for(var i=0; i<discount_set.length; i++) {
          let d = discount_set[i]
          if(quantity >= d.quantity) {
            matchingDiscount = d
            break;
          }
        }

        if(typeof matchingDiscount !== "undefined") {
            // if discount defined in percentage
            if(matchingDiscount.is_percentage) {
              item['discount_value'] = calculateDiscount(item.price, matchingDiscount.rate)
            }
            else {
              item['discount_value'] = matchingDiscount.value
            }
        }
        else {
              item['discount_value'] = 0
        }

    }
    else {
      item['discount_value'] = 0
    }
  }
}

handleUpdateQuantity(item) {

  // calculate price, cgst, sgst, igst, total
  let gst = item.gst

  var b = parseFloat(item.selling_basic_rate), q = parseFloat(item.quantity)
  if (isNaN(b)) {
    b = 0
  }
  if (isNaN(q)) {
    q = Number(0)
  }
  console.log(b, q);
  item['price']  = parseFloat(parseFloat(b * q).toFixed(2))
  this.getDiscount(item)
  let afterDiscount = item['price']

  if(!isNaN(item['discount_value'])) {
      afterDiscount = item['price'] - parseFloat(item['discount_value'])
  }
  else {
    // not a number
    item['discount_value'] = Number(0)
  }

  item['price'] = parseFloat(afterDiscount).toFixed(2)
  if(afterDiscount <=0) {
    afterDiscount = 0
  }
  if(typeof gst !== "undefined" && gst !== null && gst.type !== "undefined" && gst.type !== null) {
      item['cgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.cgst/100).toFixed(2) )
      item['sgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.sgst/100).toFixed(2) )
      item['igst_amount'] = parseFloat( parseFloat(afterDiscount*gst.igst/100).toFixed(2) )
  }



  item['total'] = parseFloat(parseFloat(afterDiscount +item['igst_amount']).toFixed(2))

  this.handleUpdateItem(item)
}

  handleCalculateTotal(retn_retnitem_set) {

    let total = 0, totalPrice=0, totalTax=0, totalDiscount=0
      if(typeof retn_retnitem_set !== "undefined") {
        retn_retnitem_set.forEach((item,i)=> {
          totalPrice = totalPrice + parseFloat(parseFloat(item.price).toFixed(2))
          totalDiscount = totalDiscount + parseFloat(parseFloat(item.discount_value).toFixed(2))
          totalTax = totalTax + parseFloat(parseFloat(item.igst_amount).toFixed(2))
          total = total + parseFloat(parseFloat(item.total).toFixed(2))
        })
      }

      totalPrice = parseFloat(totalPrice).toFixed(2)
      totalDiscount = parseFloat(totalDiscount).toFixed(2)
      totalTax = parseFloat(totalTax).toFixed(2)
      total = parseFloat(total).toFixed(2)
      this.modifyItemState('totalPrice', totalPrice)
      this.modifyItemState('totalDiscount', totalDiscount)
      this.modifyItemState('totalTax', totalTax)
      this.modifyItemState('total', total)
  }


  handleUpdateItem(item) {
    if(typeof item.discount_value === "undefined") {
      item['discount_value'] = ""
    }

    let retn = this.state.retn
    let retn_retnitem_set
    if(typeof retn.retnitem_set !== "undefined") {
        retn_retnitem_set = retn.retnitem_set.filter(obj=> obj.tableIndex !== item.tableIndex)
    }

    retn_retnitem_set = retn_retnitem_set.concat(item)
    this.modifyItemState('retnitem_set', retn_retnitem_set)
    this.handleCalculateTotal(retn_retnitem_set)
  }

  handleDeleteItem(item_index){
    let retn = this.state.retn
    let retn_retnitem_set = []
    if(typeof retn.retnitem_set !== "undefined") {
        retn_retnitem_set = retn.retnitem_set.filter((item,i)=> item.tableIndex !== item_index)

        const reIndexed = retn_retnitem_set.map((item,i)=>{
            item['tableIndex'] = i+1
            return item
        })
        this.modifyItemState('retnitem_set', reIndexed)
        this.setState({retn_item_tableindex: retn_retnitem_set.length})
        this.handleCalculateTotal(retn_retnitem_set)
    }

  }

  handleAddItem(item) {
    let retn = this.state.retn
    let retn_retnitem_set = []
    if(typeof retn.retnitem_set !== "undefined") {
        retn_retnitem_set= retn.retnitem_set
    }

    retn_retnitem_set.push(item)
    this.modifyItemState('retnitem_set', retn_retnitem_set)

  }

  modifyItemState(key, value) {
        let currentRetn = this.state.retn
        currentRetn[key] = value
        this.setState({
          retn:currentRetn
       });
  }


  handleClientChange(client) {
    this.modifyItemState('client', client)

    this.modifyItemState('invoice', null)
    this.getClientInvoices(client.id).then((response)=>{
      if(response.status===200) {
        this.setState({invoiceOptions: response.data.invoices, loadingInvoices:false})
      }
    }).catch((err)=>{
      this.setState({loadingInvoices:false})
    })

    let profile = getUserProfile()
    if(profile.tax_type === "G") {
      let gstin = profile.gstin
      let client_gstin = client.gstin
      if(gstin && client_gstin) {
          if(gstin.substring(0,2) !== client_gstin.substring(0,2)) {
            this.modifyItemState('is_igst', true)
          }
          else {
            this.modifyItemState('is_igst', false)
          }
      }
    }

  }

  handleInvoiceChange(invoice) {
    this.modifyItemState('invoice', invoice)
  }

  handleOutStateChange(outstate) {
    this.modifyItemState('is_igst', outstate)
  }
  handleDateChange(date){
    this.modifyItemState('date', date)
  }



  handleAddRow(event) {
    let tableIndex
    if(typeof this.state.retn_item_tableindex !== "undefined") {
      tableIndex = this.state.retn_item_tableindex + 1
    }
    else {
      tableIndex = 1
    }
    const emptyData = {hsn:"", quantity:0, mrp:0, gst:{}, serial:0,
      discount_value:0, selling_basic_rate:0, basic_purchase_rate:0, selling_rate:0, price:0, tax:0, total:0, tableIndex:tableIndex,
      cgst_amount:0, sgst_amount:0, igst_amount:0, discount_set:[]}
    this.handleAddItem(emptyData)
    this.setState({retn_item_tableindex:tableIndex})

  }

  deleteRetn() {
    let confirmation = window.confirm('You are about to delete this credit note !')
    if(confirmation) {
      axios({
        url: '/delete_retn/',
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.retn
      }).then((response)=> {
        if(response.status === 200) {
            NotificationManager.success("Deleted Credit Note successfully")
          setTimeout(()=>{
            this.props.history.push("/credit_notes/")
          }, 700)
        }
      }).catch((err)=> {
        console.log(err);
      })
    }

  }

  submit(e) {
    this.setState({'submitting':true})
    let action = e.target.name;
    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_retn/"
    }
    else {
      apiurl  = "/create_new_retn/"
    }


    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.retn
    }).then((response)=> {
      this.setState({'submitting':false})
      if(response.status === 200) {
        let responsedRetn = response.data.retn
        if(this.state.mode === "edit") {
            NotificationManager.success("Updated Credit Note successfully")
        }
        else {
          NotificationManager.success("Created Credit Note successfully")
        }

        if(action === "saveprint") {
          this.props.history.push("/credit_notes/preview/"+responsedRetn.serial+"/?print=true")
        }
        else {
          setTimeout(()=>{
            this.props.history.push("/credit_notes/")
          }, 700)
        }

      }
    }).catch((err)=> {
      this.setState({'submitting':false})
      console.log(err);
    })
  }

  renderOption(option) {
    return <span>Invoice {option.series_name + "" + option.series_counter }</span>
  }



  render() {

      let retn = this.state.retn
      let submitButton = <input type="submit" className="btn btn-success" value="save" onClick={this.submit} />
      let saveAndPrintButton = <input type="submit" name="saveprint" className="btn btn-success" value="Save & Preview" onClick={this.submit} />
      if(this.state.submitting) {
        submitButton = <input type="submit" className="btn btn-success" value="saving.." disabled />
        saveAndPrintButton = <input type="submit" className="btn btn-success" value="Saving.." disabled />
      }

      let client = <ClientElement retn={retn} onAddCallback={this.handleClientChange} />

      let rowELements = []
      if(typeof retn.retnitem_set !== "undefined") {

        retn.retnitem_set.sort((a,b)=>{
          return a.tableIndex - b.tableIndex
        })

        rowELements = retn.retnitem_set.map((item, i)=>{

          i++
          return <ResponsiveRow retn={retn} item={item} rowno={i} key={i} deleteRow={this.handleDeleteItem}
          handleUpdateItem={this.handleUpdateItem}
          handleUpdateQuantity = {this.handleUpdateQuantity}
          handleUpdateBasicRate = {this.handleUpdateBasicRate}
          handleUpdateSellingPrice = {this.handleUpdateSellingPrice}
           />
        })
      }



      let pageHeader
      let deleteRetnBtn, previewLink
      if(!this.state.loading) {

        let invoiceOptions = this.state.invoiceOptions

        if(this.state.mode === "edit") {
          pageHeader = <h3>{"Edit Credit Note  #" + retn.serial}</h3>
          deleteRetnBtn = <button className="btn btn-sm btn-danger" onClick={this.deleteRetn}>Delete Credit </button>
          previewLink = <Link to={"/credit_notes/preview/"+this.props.match.params.retn_id} className="btn btn-primary" > Preview</Link>
        }
        else {
          pageHeader =  <h3>Create New Credit Note</h3>
        }

        return <div>
        <section className="medium">
              {pageHeader}
              <ul className="list-inline">
                <li>{previewLink}</li>
                <li className="pull-right">{deleteRetnBtn}</li>
              </ul>

        </section>
            <section className="small">
              <div className="row">
                <div className="col-sm-2">
                  <h4>Client</h4>
                  {client}
                </div>
                <div className="col-sm-2">
                <h4>Invoice</h4>

                <Select multi={false} onChange={this.handleInvoiceChange} valueRenderer={this.renderOption} openOnFocus={true}
                options={invoiceOptions} optionRenderer={this.renderOption} value={retn.invoice} />

                </div>
                <div className="col-sm-2">
                  <h4>Date</h4>
                  <RetnDate retn={retn} handleDateChange={this.handleDateChange} />
                </div>
                <div className="col-sm-1">
                  <h4>Out of State Bill ?</h4>
                  <OutState retn={retn}  onChangeCallback={this.handleOutStateChange} />
                </div>

                <div className="col-sm-2">
                  <h4>Reason</h4>
                  <select className="form-control" value={retn.reason} onChange={this.handleReasonChange}>
                    <option value="Sales Return">Sales Return</option>
                    <option value="Post Sale Discount">Post Sale Discount</option>
                    <option value="Deficiency In Services">Deficiency In Services</option>
                    <option value="Correction In Invoice">Correction In Invoice</option>
                    <option value="Change In POS">Change In POS</option>
                    <option value="Finalization of Provisional Assesment">Finalization of Provisional Assesment</option>
                    <option value="Others">Others</option>

                  </select>
                </div>

              </div>
            </section>
            <section className="small">

            <div className="row">
              <div className="col-sm-12">
                <div className="">
                    <ResonsiveHeader retn={retn} />
                    {rowELements}

                    <div className="panel-body">
                    <AddRetnRow handleAddRow={this.handleAddRow}  />
                    </div>

                  <RetnTotal retn={retn} />
                </div>

                <div className="text-right">
                  <ul className="list-inline">
                      <li>{submitButton}</li>
                      <li>{saveAndPrintButton}</li>
                  </ul>
                </div>
              </div>
            </div>

            </section>


          </div>

      }
      else {
        return <div>
            <Loader />
        </div>
      }



  }
}



// WEBPACK FOOTER //
// ./src/components/credit/addcreditnote.js